export default "__VITE_ASSET__aed2163e__"